import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';

// Constants
import { ROUTE_PATHS } from '../../constants/routes';

// Types
import { IStore } from '../../store/Store';

// Services
import { createUser, meUploadPhoto } from '../../services/user';

// Components
import Box from '../../components/Box';
import Button from '../../components/Button';
import { AlertDialog } from '../../components/Dialog';
import Divider from '../../components/Divider';
import { EntryLayout } from '../../components/Layout';
import Icon from '../../components/Icon';
import MobileStepper from '../../components/MobileStepper';

import AccountStep, { AccountFormState } from './AccountStep';
import PersonalStep, { PersonalFormState } from './PersonalStep';
import AvatarStep from './AvatarStep';

// Component
interface IProps {
  store?: IStore;
}

class SignUp extends React.Component<IProps, {}> {
  accountForm = new AccountFormState();
  personalForm = new PersonalFormState();
  avatarDataUrl: string | null = null;

  @observable stepperIndex: number = 0;

  @observable
  alertDialogState = {
    open: false,
    title: '',
    description: ''
  };

  handleMobileStepperNext = async () => {
    if (this.stepperIndex === 0) {
      const validation = await this.accountForm.state.validate();
      if (validation.hasError === false) {
        this.stepperIndex += 1;
      }
    } else if (this.stepperIndex === 1) {
      const validation = await this.personalForm.state.validate();
      if (validation.hasError === false) {
        this.stepperIndex += 1;
      }
    } else if (this.stepperIndex === 2) {
      const accountForm = this.accountForm.getValues();
      const personalForm = this.personalForm.getValues();

      await createUser({
        body: { ...accountForm, ...personalForm }
      });
      await this.props.store!.meStore!.login({
        username: accountForm.email,
        password: accountForm.password,
        remember: true
      });
      if (this.avatarDataUrl) {
        await meUploadPhoto({
          body: {
            base64: this.avatarDataUrl
          }
        });
      }

      this.props.store!.routerStore!.navigate(ROUTE_PATHS.APP);
    } else {
      this.stepperIndex += 1;
    }
  };

  handleAccountSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validation = await this.accountForm.state.validate();
    if (validation.hasError === false) {
      this.stepperIndex += 1;
    }
  };

  handlePersonalSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const validation = await this.personalForm.state.validate();
    if (validation.hasError === false) {
      this.stepperIndex += 1;
    }
  };

  handleImageConfirm = (dataUrl: string) => {
    this.avatarDataUrl = dataUrl;
  };

  handleMobileStepperBack = () => {
    if (this.stepperIndex === 0) {
      this.props.store!.routerStore!.navigate(ROUTE_PATHS.LOGIN);
    }
    this.stepperIndex -= 1;
  };

  handleErrorDialogClose = () => {
    this.alertDialogState.open = false;
  };

  render() {
    return (
      <EntryLayout>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            width: '100%'
          }}
        >
          <div
            style={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Box pa={5}>
              {this.stepperIndex === 0 ? (
                <AccountStep
                  formState={this.accountForm}
                  onSubmit={this.handleAccountSubmit}
                />
              ) : null}
              {this.stepperIndex === 1 ? (
                <PersonalStep
                  formState={this.personalForm}
                  onSubmit={this.handlePersonalSubmit}
                />
              ) : null}
              {this.stepperIndex === 2 ? (
                <AvatarStep
                  image={this.avatarDataUrl}
                  onConfirm={this.handleImageConfirm}
                />
              ) : null}
            </Box>
          </div>
          <div>
            <Divider />
            <MobileStepper
              activeStep={this.stepperIndex}
              type="dots"
              position="static"
              backButton={
                <Button dense={true} onClick={this.handleMobileStepperBack}>
                  <Icon>keyboard_arrow_left</Icon>
                  Back
                </Button>
              }
              nextButton={
                <Button
                  dense={true}
                  onClick={this.handleMobileStepperNext}
                  disabled={this.stepperIndex === 5}
                >
                  Next
                  <Icon>keyboard_arrow_right</Icon>
                </Button>
              }
              steps={3}
            />
          </div>
          <AlertDialog
            state={this.alertDialogState}
            onClose={this.handleErrorDialogClose}
            onConfirm={this.handleErrorDialogClose}
          />
        </div>
      </EntryLayout>
    );
  }
}

export default inject('store')(observer(SignUp));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/SignUp/SignUp.tsx